<script setup lang="ts">
import { ref } from 'vue';
import { default as ButtonEl } from '@/components/shared/Button.vue';
import { IShift } from '@/interfaces';

const emit = defineEmits(['update']);

interface Props {
  shift: IShift;
}

withDefaults(defineProps<Props>(), {});

const isEditing = ref(false);
const confirmation = ref(false);
const confirmButtonText = ref('');
const action = ref('');

function cancel() {
  confirmButtonText.value = 'scheduleShift.confirmCancelationButton';
  action.value = 'cancel';
  confirmation.value = true;
}

function reactivate() {
  confirmButtonText.value = 'scheduleShift.confirmReactivationButton';
  action.value = 'reactivate';
  confirmation.value = true;
}

function remove() {
  confirmButtonText.value = 'scheduleShift.confirmDeleteButton';
  action.value = 'delete';
  confirmation.value = true;
}

async function replace() {
  action.value = 'replace';
  emit('update', 'replace');
}
</script>

<template>
  <div class="flex justify-evenly w-full bottom-16">
    <ButtonEl
      v-if="!isEditing"
      text="scheduleShift.editShiftButton"
      :icon="['fal', 'fa-edit']"
      :shadow="true"
      class="self-center"
      background="bg-neutral-0"
      textColor="text-neutral-1000"
      @click="isEditing = !isEditing"
    />

    <div v-if="isEditing && !confirmation" class="flex justify-evenly w-full">
      <ButtonEl
        v-if="!shift.cancelled"
        text="scheduleShift.cancelButton"
        :icon="['fal', 'fa-ban']"
        :shadow="true"
        class="self-center"
        background="bg-yellow-300"
        @click="cancel()"
      />

      <ButtonEl
        v-if="shift.cancelled"
        text="scheduleShift.reactivateButton"
        :icon="['fal', 'fa-exchange-alt']"
        :shadow="true"
        class="self-center"
        background="bg-yellow-300"
        @click="reactivate()"
      />

      <ButtonEl
        text="scheduleShift.replace"
        :icon="['fal', 'fa-exchange-alt']"
        :shadow="true"
        class="self-center"
        background="bg-green-400"
        @click="replace()"
      />

      <ButtonEl
        text="scheduleShift.delete"
        :icon="['fal', 'fa-trash']"
        :shadow="true"
        class="self-center"
        background="bg-red-400"
        @click="remove()"
      />
    </div>

    <div v-if="confirmation" class="flex justify-evenly w-full">
      <ButtonEl
        :text="confirmButtonText"
        :icon="['fal', 'fa-ban']"
        :shadow="true"
        class="self-center"
        :background="action === 'cancel' ? 'bg-yellow-300' : 'bg-red-400'"
        @click="emit('update', action)"
      />

      <ButtonEl
        text="global.cancel"
        :icon="['fal', 'fa-undo']"
        :shadow="true"
        class="self-center"
        textColor="text-neutral-1000"
        background="bg-neutral-0"
        @click="confirmation = !confirmation"
      />
    </div>
  </div>
</template>
